(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/best-rows/assets/javascripts/views/best-rows-matches.js') >= 0) return;  svs.modules.push('/components/sport/best-rows/assets/javascripts/views/best-rows-matches.js'); 'use strict';

svs.sport.best_rows.views.BestRowsMatches = Marionette.CollectionView.extend({
  log: new svs.core.log.Logger('svs.sport.best_rows.models.BestRowsMatches'),
  tagName: 'table',
  className: 'best-rows',
  attributes: {
    cellpadding: 0,
    cellspacing: 0
  },
  collectionEvents: {
    modeChange: 'render'
  },
  childView: svs.sport.best_rows.views.BestRowMatch
});
 })(window);